import { StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useWorkspaceType } from 'zens-store'
import { BreadcrumbData, PageHeaderProps } from 'zens-storybook'
import { useBreadcrumb } from '@dms/hook'

import { LayoutHeader } from '../layout'
const styles = StyleSheet.create({
  container: {},
})

interface Props extends PageHeaderProps {
  companyId: number
  workspaceTypeId: number
  breadcrumbItems?: BreadcrumbData[]
}

const WorkspaceTypeHeader = (props: Props) => {
  const { companyId, workspaceTypeId, breadcrumbItems, style, ...otherProps } = props
  const { t } = useTranslation()
  const workspaceType = useWorkspaceType({ workspaceTypeId })

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspace types'),
      href: { pathname: `/workspacetypes`, params: { companyId } },
    },
    {
      title: `${workspaceType.data?.name}`,
    },
    ...(breadcrumbItems || []),
  ])

  return (
    <LayoutHeader
      style={[styles.container, style]}
      breadcrumb={breadcrumb}
      title={workspaceType.data?.name}
      menu={undefined}
      {...otherProps}
    />
  )
}

export default WorkspaceTypeHeader
